import { createSlice } from "@reduxjs/toolkit";

const defaultUser = {
  remember: false,
  logged: false,
  session: "",
  api: "",
  userInfo: {},
};

const collectionSlice = createSlice({
  name: "root",
  initialState: {
    channels: [],
    folder: null,
    message: [
      {
        type: "paragraph",
        children: [{ text: "" }],
      },
    ],
    workflowStep: 0,
    user: defaultUser,
    auth: {
      askLogin: false,
      key: "",
    },
    client: null,
    theme: "light",
  },
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === "light" ? "dark" : "light";
    },
    initClient: (state, action) => {
      state.client = action.payload;
    },
    apiLogin: (state, action) => {
      state.user = action.payload;
    },
    apiLogout: (state) => {
      state.user = defaultUser;
    },
    setWorkflowStep: (state, action) => {
      state.workflowStep = action.payload;
    },
    setAskLogin: (state, action) => {
      state.auth = { ...state.auth, askLogin: action.payload };
    },
    addChannels: (state, action) => {
      state.channels = action.payload;
    },
    removeChannels: (state) => {
      state.channels = [];
    },
    selectedFolder: (state, action) => {
      state.folder = action.payload;
    },
    removeFolder: (state) => {
      state.folder = null;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    removeMessage: (state) => {
      state.message = [
        {
          type: "paragraph",
          children: [{ text: "" }],
        },
      ];
    },
  },
});

const { actions, reducer } = collectionSlice;

export const {
  apiLogin,
  setAskLogin,
  apiLogout,
  initClient,
  toggleTheme,
  addChannels,
  setWorkflowStep,
  removeChannels,
  selectedFolder,
  removeFolder,
  setMessage,
  removeMessage,
} = actions;

export default reducer;
